'use strict';

import $ from 'jquery';
import {is_defined, is_function} from "../../Helpers/js";
import {pubsub} from '../PubSub.js';
import {Component} from '../Component.js';

export class Modal extends Component {
    constructor(settings) {
        super(settings.selector || null);
        this.settings = settings || {};
        this.$modal = $(`<div class="ui ${this.settings.size || ''} modal"><div class="ui active huge loader"/></div>`);
    }

    init(elm) {
        $(elm).on('click', () => this.open());
    }

    open(html) {
        if (this.settings.closeOn) {
            this.subscription = pubsub.subscribe(this.settings.closeOn, () => this.close());
            this.$modal.data('subscription', this.subscription);
        }

        this.$modal.modal({
            blurring: false, // tooltips in modals will be blurred. we'll containerTimeout for fix from SUI
            autofocus: false,
            duration: 250,
            observeChanges: true,
            onApprove: this.settings.onApprove || (() => false),
            onDeny: this.settings.onDeny || (() => this.close()),
            onHide: () => this._cleanUp(),
            onHidden: () => this.$modal.remove()
        })
            .modal('show');

        if (html) {
            this._show(html);
        } else if (is_function(this.settings.html)) {

            // params.html can be called with or without params.data:
            // 1. params.html(params.data, onSuccess, onError)
            // 2. params.html(onSuccess, onError)
            if (is_defined(this.settings.data)) {
                this.settings.html(this.settings.data, (json) => this._show(json.html));
            } else {
                this.settings.html((json) => this._show(json.html));
            }
        } else if (is_function(this.render)) {
            this.render(html => this._show(html));
        } else {
            this._show('no content');
        }
    }

    _show(html) {
        this.$modal.html(html);
        this.$modal.find('a.text.link:not([data-action])').on('click', () => this.close());

        is_function(this.settings.onLoad) && this.settings.onLoad.call(this.$modal);
    }

    close() {
        this._cleanUp();
        this.$modal.modal('hide').remove();
    }

    _cleanUp() {
        is_function(this.settings.onClose) && this.settings.onClose.call(this.$modal);
        this.subscription && this.subscription.remove();
    }

    static closeAll() {
        $('.ui.modals .ui.modal').each(function () {
            let $me = $(this);
            $me.modal('hide').remove();
            $me.data('subscription') && $me.data('subscription').remove();
        });
    }

    html(title, content, approve, cancel) {
        return `
<div class="header">${title}</div>
<div class="content">${content}</div>
<div class="actions">
    <div class="ui cancel button">
        <i class="icon-cancel-5"></i>${cancel}
    </div>
    <div class="ui green approve button">
       <i class="check icon"></i>${approve}
    </div>
</div>
`;
    }
}
